module.exports = __webpack_public_path__ + "img/textalign-center.da2fcfaf.svg";